import { MenuProps } from '@material-ui/core';

export const DEFAULT_TABLE_SIZE = 2;

export const JWT_TOKEN_NAME = 'jwtToken';

export const MenuListProps: Partial<MenuProps> = {
    MenuListProps: { disablePadding: true },
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
    },
    getContentAnchorEl: null
};

export const SEARCH_DEBOUNCE = 350;

export const IS_ROSSUM_ENABLED = false;
